import RoomIndexVue from "@/views/room/RoomIndex.vue";

const room = [
  {
    path: "/room",
    name: "room",
    component: RoomIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","receptionist","supervisor"],
      public: false,
    },
  },
];

export default room;
